export class EmailOrPasswordNotCorrect extends Error {
  constructor() {
    super(`Email or password not correct`);
  }
}
